<template>
  <b-modal
    ref="modal"
    title="Novo Acompanhamento Externo"
    size="md"
    ok-title="Salvar"
    cancel-title="Cancelar"
    @ok="onSaveClicked($event)"
  >
    <b-form>
      <b-row v-if="responses.length > 0">
        <b-col cols="6">
          <b-form-group label="Respostas padrões">
            <b-form-select
              v-model="response"
              value-field="text"
              :options="responses"
              @change="onResponseSelected"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Descrição">
            <b-form-textarea
              v-model="monitoring.description"
              v-validate="rules.description"
              type="text"
              class="form-control"
              :rows="4"
              :max-rows="4"
              aria-describedby="invalidDescription"
              name="description"
              :state="validateState('description')"
            ></b-form-textarea>
            <b-form-invalid-feedback id="invalidDescription">
              {{ errors.first("description") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import { createMonitoring } from "../../api/complaint";
import { getResponses } from "../../api/company";

export default {
  name: "MonitoringModal",
  props: {
    complaint: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      monitoring: {},
      responses: [],
      response: null,
      rules: {
        description: { required: true },
      },
    };
  },
  async created() {
    this.responses = (await getResponses(this.complaint.company._id)).data;
    this.responses.unshift({ text: "Selecione uma opção", disabled: true });
  },
  methods: {
    validateState(ref) {
      if (
        this.vFields[ref] &&
        (this.vFields[ref].dirty || this.vFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    onResponseSelected(text) {
      this.monitoring.description = text;
      this.response = null;
    },

    async onSaveClicked(bvEvt) {
      bvEvt.preventDefault();
      const validated = await this.$validator.validateAll();

      if (!validated) {
        return;
      }

      try {
        await createMonitoring(this.complaint._id, this.monitoring);
      } catch (error) {
        if (error.response.status === 403 || error.response.status === 404) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
        return;
      }

      this.$bvToast.toast("Acompanhamento Externo criado com sucesso!", {
        title: "Sucesso",
        toastClass: "custom-toast custom-toast-success",
        variant: "light",
        solid: true,
        autoHideDelay: 5000,
        noCloseButton: false,
      });
      this.$emit("new-monitoring");

      this.$refs.modal.hide();
    },

    show() {
      this.$refs.modal.show();
    },
  },
};
</script>
